import {toLocalDate} from "../utils/formatData";

const rolesColumns = [
  {
    field: "name",
    headerName: "Name",
    width: 150,
    editable: false
  },
  {
    field: "description",
    headerName: "Description",
    width: 150,
    editable: false
  }
];

const userColumns = [
  {
    field: "name",
    headerName: "Name",
    width: 150,
    editable: false
  },
  {
    field: "surname",
    headerName: "Surname",
    width: 150,
    editable: false
  },
  {
    field: "email",
    headerName: "Email",
    width: 150,
    editable: false
  },
  {
    field: "client_code",
    headerName: "Client Code",
    width: 150,
    editable: false
  }
];

const clientColumns = [
  {
    field: "name",
    headerName: "Nombre",
    width: 200,
    editable: false
  },
  {
    field: "allowed_grants",
    headerName: "Allowed grants",
    width: 200,
    editable: false
  },
  {
    field: "redirect_uris",
    headerName: "Redirect URIs",
    width: 180,
    editable: false
  },
  {
    field: "created_at",
    headerName: "Creado",
    width: 180,
    editable: false
  }
];

const m2mTokenColumns = [
  {
    field: "active",
    headerName: "Activo",
    width: 100,
    editable: false,
    type: "boolean"
  },
  {
    field: "token",
    headerName: "Token",
    width: 200,
    editable: false
  },
  {
    field: "domain",
    headerName: "Domain",
    width: 200,
    editable: false
  },
  {
    field: "payload",
    headerName: "Actions",
    width: 300,
    editable: false,
    renderCell: (params) => {
      return params.value ? JSON.stringify(params.value.actions) : "";
    }
  },
  {
    field: "created_at",
    headerName: "Fecha creación",
    width: 180,
    editable: false,
    renderCell: (params) => {
      return toLocalDate(params.value);
    }
  },
  {
    field: "expiration",
    headerName: "Fecha expiración",
    width: 180,
    editable: false,
    renderCell: (params) => {
      const payload = params.row?.payload;
      if (payload && payload.exp) {
        return toLocalDate(new Date(payload.exp * 1000).toISOString());
      }
      return "";
    }
  }
];

const tokenColumns = [
  {
    field: "token",
    headerName: "Token",
    width: 200,
    editable: false
  },
  {
    field: "type",
    headerName: "Tipo",
    width: 200,
    editable: false
  },
  {
    field: "expires_at",
    headerName: "Fecha expiración",
    width: 180,
    editable: false,
    renderCell: (params) => {
      return toLocalDate(params.value);
    }
  },
  {
    field: "email",
    headerName: "Usuario",
    width: 180,
    editable: false
  }
];

const scopesColumns = [
  {
    field: "name",
    headerName: "Name",
    width: 150,
    editable: false
  },
  {
    field: "description",
    headerName: "Description",
    width: 150
  }
];

export {rolesColumns, userColumns, clientColumns, tokenColumns, scopesColumns, m2mTokenColumns};
